import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

import preventNestedInstances from '../../common/utils/prevent-nested-instances';
import initializeEngagementStore from '../engagement-store';
import { EngagementProvider } from './main';

// This extra bit of typing is required because typing on analytics-next
// doesn't seem to be working properly and we haven't been able to
// come up with a solution for it yet. Also analytics-next is in
// maintenance mode so will need to be replaced anyway.

var EngagementProviderWithEvents = withAnalyticsEvents()(EngagementProvider);
var EngagementProviderWithDefaultStore = function EngagementProviderWithDefaultStore(props) {
  return /*#__PURE__*/React.createElement(EngagementProviderWithEvents, _extends({}, props, {
    store: initializeEngagementStore(props.config)
  }));
};
export default preventNestedInstances(EngagementProviderWithDefaultStore);